module.exports = {
	"articleTitle1": "Best Vegetarian / Vegan: The Lunch Room ",
	"catImage": "greenstar.png",
	"totalCats": 1,
	"name": "The Lunch Room",
	"articleLink1": "#",
	"articleLink2": "https://www.michigandaily.com/section/arts/boaa-lunch-room",
	"articleSnippet1": "Apr 2, 2017 ... Walking into The Lunch Room, you can immediately feel the friendliness and \ntempeh in the air.",
	"articleSnippet2": "Apr 1, 2016 ... The first thing you'll notice when walking into The Lunch Room is probably the \ngiant case of desserts. From bundt cake to cupcakes to cookies ...",
	"foodRecommendations": [
		{
			"text": "The Power Up Bowl is delicious, and the Mac N Cheese is some of the best vegan mac I've had",
			"person": "Anon"
		}
	],
	"articleTitle2": "Best Vegetarian/Vegan Food: The Lunch Room ",
	"address": "407 N 5th Ave, Ann Arbor, MI 48104",
	"images": [
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/170412/msh.NEW_.TheLunchRoomBOAA.3.31.16.051.jpg?itok=gWU3leyF",
			"author": "File Photo",
			"caption": ""
		},
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/160414/msh.NEW_.TheLunchRoomBOAA.3.31.16.027.jpg?itok=xdA4BndF",
			"author": "Mazie Hyams",
			"caption": ""
		}
	],
	"position": {
		"lat": 42.284546,
		"lng": -83.746488
	},
	"totalMisc": 1,
	"categories": {
		"bestofaa": 1,
		"fooddrink": 1,
		"location": 1,
		"restaurant": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/lunchroom.json
// module id = 910
// module chunks = 0